/**
 * @generated SignedSource<<51f9f744203c7ef37161cb984a2e4096>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type resolutionGroupHeader_issueTableGrouping$data = {
  readonly displayName: string;
  readonly resolution: {
    readonly id: string;
    readonly name: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "resolutionGroupHeader_issueTableGrouping";
};
export type resolutionGroupHeader_issueTableGrouping$key = {
  readonly " $data"?: resolutionGroupHeader_issueTableGrouping$data;
  readonly " $fragmentSpreads": FragmentRefs<"resolutionGroupHeader_issueTableGrouping">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "resolutionGroupHeader_issueTableGrouping",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "displayName"
    },
    {
      "concreteType": "JiraResolution",
      "kind": "LinkedField",
      "name": "resolution",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "id"
        },
        {
          "kind": "ScalarField",
          "name": "name"
        }
      ]
    }
  ],
  "type": "JiraJqlResolutionFieldValue"
};

(node as any).hash = "b210ce2bdf11caef915ebd09c93be95b";

export default node;
